import type { FC } from 'react'

import {
  TextButtonStyled,
  type ITextButtonStyledProps,
} from './styles/TextButtonStyled'

export interface ITextButtonProps extends ITextButtonStyledProps {}

export const TextButton: FC<ITextButtonProps> = TextButtonStyled

TextButton.displayName = 'TextButton'
